import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store/root-reducer';

import { validateDraft } from '../../_shared/domain/administrator-draft.validation';

const selectAddAdministrator = (state: RootState) => state.addAdministrator;

export const selectDraft = (state: RootState) => selectAddAdministrator(state).draft;
export const selectSaveStatus = (state: RootState) => selectAddAdministrator(state).saveStatus;
export const selectError = (state: RootState) => selectAddAdministrator(state).error;
export const selectValidationErrors = (state: RootState) =>
  selectAddAdministrator(state).validationErrors;

export const selectIsSaving = (state: RootState) =>
  selectAddAdministrator(state).saveStatus === 'saving';

/** Derived: is the current draft valid? Memoised on the draft reference. */
export const selectIsDraftValid = createSelector(
  selectDraft,
  (draft) => Object.keys(validateDraft(draft)).length === 0,
);

/** Derived: why the LinkedIn URL is refused, if it is (#617). Memoised on the draft. */
export const selectLinkedInUrlError = createSelector(
  selectDraft,
  (draft) => validateDraft(draft).linkedinUrl,
);
